

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '博物馆名称',
    },
    {
      key: 'region',
      dataIndex: 'region',
      title: '地区',
    },
    {
      key: 'applylevel',
      dataIndex: 'applylevel',
      title: '申报等级',
    },
    {
      key: 'regtime',
      dataIndex: 'regtime',
      title: '注册时间',
    },
    {
      key: 'adminname',
      dataIndex: 'adminname',
      title: '管理员姓名',
    },
    {
      key: 'adminphone',
      dataIndex: 'adminphone',
      title: '管理员手机号',
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: '审核状态',
    },
    {
      key: 'approvername',
      dataIndex: 'approvername',
      title: '审核人',
    },
    {
      key: 'approvetime',
      dataIndex: 'approvetime',
      title: '审核时间',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '操作',
      width: 100,
      slot: 'operate',
      fixed: 'right',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
